import 'react-toastify/dist/ReactToastify.css';
import GoogleLoginComponent from "../components/GoogleLogin";


const Signin = () => {

  return (
    <div className={'mainContainer'}>
      <GoogleLoginComponent />
    </div>
  )
}

export default Signin